import React, { useCallback, useEffect, useState } from 'react'
import { Form, Button, Container, Row, Col, InputGroup } from 'react-bootstrap'
import { Footer, KonektoNavbar } from '../../components'
import './CreateRequest.scss'
import '../../../src/App.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { hasValue } from '../../helpers'
import { FaSearch } from 'react-icons/fa'

export default function CreateRequestStart() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { token } = useSelector(state => state.authentication)

  const [searchQuery, setSearchQuery] = useState('')

  const onSearchSubmit = e => {
    e.preventDefault()
    if (hasValue(searchQuery)) {
      navigate(`/zahtjevi/kreiraj?q=${searchQuery}`)
    }
  }

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'instant' })
    }, 100)
  }, [])

  return (
    <div id="create-request-start">
      <KonektoNavbar />
      <div className="wrapper">
        <div className="container pb-5">
          <div className="mb-4 mt-5">
            <h4 className="section-header text-center">Pošalji zahtjev</h4>
          </div>

          <p className="text-center fs-4">
            Pošalji jedan zahtjev i dobij više pounda od odgovarajućih firmi.
          </p>

          <div className="row info mt-5">
            <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center">
              <Form onSubmit={onSearchSubmit} className="">
                <InputGroup className={`rounded-pill search-bar`}>
                  <Form.Control
                    type="text"
                    placeholder="Voće, pakovanje, stolarija..."
                    className="rounded-pill"
                    aria-label="Search"
                    value={searchQuery}
                    onChange={e => {
                      setSearchQuery(e.target.value)
                    }}
                  />
                </InputGroup>
              </Form>
              <button
                onClick={onSearchSubmit}
                className="btn btn-primary rounded-pill mt-3 fw-bold fs-5 search-button">
                Dobij više ponuda
              </button>
            </div>

            <div className="col-12 col-md-6 d-flex flex-column justify-content-center">
              <ul>
                <li className="mt-2">Naći ćemo relevantne dobavljače</li>
                <li className="mt-2">
                  Dobit ćete više odgovora u roku od 24 sata
                </li>
                <li className="mt-2">
                  100% besplatno i u skladu sa zakonima o zaštiti podataka
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
